import React from "react";
import Button from "../../../form/Button";
import Image from "../../../elements/Image";
import { lngDetect } from "../../../../helpers/lngDetect";
import dayjs from "dayjs";
import { t } from "i18next";

const EventInfoPreview = ({ data = {} }) => {
  return (
    <>
      <h4 className="text-3xl text-deep-purple font-bold">
        {t("Your event is almost ready to publish")}
      </h4>
      <div className="text-lg text-black font-light">
        {t("Review your settings and let everyone find your event.")}
      </div>
      <div className="bg-slate-100 rounded-xl px-4 py-4">
        <div className="relative bg-white rounded-xl px-4 py-4">
          {data?.gallery && (
            <div className="w-full aspect-[3/1] rounded-xl overflow-hidden">
              <Image
                src={data?.gallery?.at(-1)?.url}
                classes={"object-cover"}
              />
            </div>
          )}
          <div className="space-y-1 mt-5">
            <div className="text-black text-xl font-bold mt-3 capitalize">
              {lngDetect(data?.title)}
            </div>
            <div className="text-black text-lg font-medium">
              {dayjs(data?.startDate).format("ddd, DD MMM YYYY")}{" "}
              {dayjs(data?.startDate).format("hh:mm A")} -{" "}
              {dayjs(data?.endDate).format("ddd, DD MMM YYYY")}{" "}
              {dayjs(data?.endDate).format("hh:mm A")}
            </div>
            {/* <div className="text-slate-500 text-lg font-medium">
              Ramchandrapur North PO- Narendrapur, PS- Sonarpur, kolkata, west
              700103
            </div> */}
          </div>
          {/* <div className="flex items-center gap-10">
            <div className="text-black text-lg font-semibold">
              <i class="fa-regular fa-receipt"></i> $11.00
            </div>
            <div className="text-black text-lg font-semibold">
              <i class="fa-regular fa-user"></i> 22
            </div>
            <div className="relative ml-auto">
              <Button
                buttonHasLink={true}
                buttonLink={"/"}
                buttonIconPosition="left"
                buttonIcon={"fa-regular fa-share-from-square"}
                buttonLabel={"Preview"}
                buttonLabelClasses={"capitalize text-lg"}
                buttonClasses={"bg-transparent px-0 text-deep-purple capitalize"}
              />
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default EventInfoPreview;
